import styled from 'styled-components';
import theme from 'theme';
import { CardBody } from 'components/Generics/Card/Card.style';

export const PoolParameterContainer = styled(CardBody)`  
  padding: 5px 0px;
  flex-direction: column;
`;

export const Prop = styled.div`
  padding: 5px 0;
  width: 50%;
  margin-right: 1em;
  @media only screen and (max-width: 768px) {
    width: 100%;
  }
`;

export const PropName = styled.div`
  color: ${theme.grey40};
  font-family: Helvetica, "Open Sans", sans-serif;
  font-size: 11px;
  font-weight: bold;
  padding: 3px 6px;
`;

export const PropValue = styled.div`
  font-family: Helvetica, "Open Sans", sans-serif;
  font-size: 11px;
  padding: 3px 6px;
  display: flex;
  align-items: center;
  color: ${theme.sherpaBlue};

  @media only screen and (min-width: 768px) {
    white-space: nowrap;
  }
`;

export const PoolPropertiesWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  min-width: 300px;
`;

export const SelectedPoolNameWrapper = styled.div`
  padding: 8px;
  border-radius: 4px;
  display: inline-flex;
  cursor: text;
  background-color: ${theme.lightestGrey};
  margin-right: 10px;
  line-height: normal;
  font-size: 13px;
  font-weight: bold;
  font-family: Helvetica, "Open Sans", sans-serif;
  color: ${theme.sherpaBlue};
  min-width: 300px;
`;

export const ModalWrapper = styled.div<{ isOpen: boolean }>`
  display: ${props => props.isOpen ? 'block' : 'none'};
`;
